import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-inactive-widget-footer',
  templateUrl: './inactive-widget-footer.component.html',
  styleUrls: ['./inactive-widget-footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InactiveWidgetFooterComponent {
  @Input()
  text: string;
}
